import { createContext } from 'preact';
import { useContext } from 'preact/hooks';
import type { EventBus } from '../core/event-bus';
import type { Store } from '../core/store';
import type { TextFilter } from '../core/text-filter';
import type { SaveService } from '../save/service';

export interface UiDeps {
  store: Store;
  bus: EventBus;
  save: SaveService;
  filter: TextFilter;
}

export const UiContext = createContext<UiDeps | null>(null);

export function useUi(): UiDeps {
  const deps = useContext(UiContext);
  if (!deps) throw new Error('UiContext missing');
  return deps;
}
